/**
 * Base da API do widget: por defeito o mesmo host de onde `widget.js` foi obtido
 * (origem do `<script src="...">`), para funcionar em LPs noutros domínios sem configurar URL à mão.
 *
 * Precedência: `apiBaseUrl` explícito → origem do script → `VITE_APP_URL` (fallback em builds especiais).
 */

function captureWidgetScriptOrigin(): string {
    if (typeof document === 'undefined') {
        return '';
    }
    const cur = document.currentScript as HTMLScriptElement | null;
    if (cur?.src) {
        try {
            return new URL(cur.src).origin;
        } catch {
            /* */
        }
    }
    const list = document.querySelectorAll<HTMLScriptElement>('script[src*="widget.js"]');
    for (let i = list.length - 1; i >= 0; i--) {
        const src = list[i].src;
        if (src) {
            try {
                return new URL(src).origin;
            } catch {
                /* */
            }
        }
    }
    return '';
}

/** Definido na primeira execução deste bundle (enquanto o browser ainda associa o script ao ficheiro). */
const WIDGET_SCRIPT_ORIGIN = captureWidgetScriptOrigin();

export function resolveWidgetApiBase(explicit?: string): string {
    const trimmed = explicit?.trim() ?? '';
    if (trimmed !== '') {
        return trimmed.replace(/\/$/, '');
    }
    if (WIDGET_SCRIPT_ORIGIN !== '') {
        return WIDGET_SCRIPT_ORIGIN;
    }
    const fromEnv = import.meta.env.VITE_APP_URL;
    if (typeof fromEnv === 'string' && fromEnv.trim() !== '') {
        return fromEnv.trim().replace(/\/$/, '');
    }
    return '';
}
